// store/modules/admin.js
import apiClient from '../../plugins/axios';
import { jwtDecode } from 'jwt-decode';

export default {
    namespaced: true,
    state: () => ({
        intercomId: null,
        allOpenTickets: [],
        assignedOpenTickets: [],
        unassignedOpenTickets: [],
        loading: false,
    }),
    mutations: {
        setAllOpenTickets(state, allOpenTickets) {
            state.allOpenTickets = allOpenTickets;
        },
        setAssignedOpenTickets(state, openTickets) {
            state.assignedOpenTickets = openTickets;
        },
        setLoading(state, loading) {
            state.loading = loading;
        },
        setIntercomId(state, intercomId) {
            state.intercomId = intercomId;
        },
        setUnassignedOpenTickets(state, unassignedOpenTickets) {
            state.unassignedOpenTickets = unassignedOpenTickets;
        }
    },
    actions: {
        async fetchIntercomId({ commit }) {
            commit('setLoading', true);
            try {
                const token = localStorage.getItem('token');
                const decoded = jwtDecode(token);
                const adminId = decoded.userId;
                const response = await apiClient.get('/getters/getIntercomIdByAdminId', {
                    params: { adminId },
                    headers: {
                        "Content-Type": "application/json",
                    }
                });
                commit('setIntercomId', response.data.intercomId);
            } catch (error) {
                console.error('Failed to fetch intercom ID:', error);
            } finally {
                commit('setLoading', false);
            }
        },
        async fetchAllOpenTickets({ commit, state }) {
            commit('setLoading', true);
            try {
                const response = await apiClient.post('/intercom/getOpenIntercomTickets', {}, {
                    headers: {
                        "Content-Type": "application/json",
                    }
                });
                const allOpenTickets = response.data;
                const assignedOpenTickets = allOpenTickets.filter(ticket => Number(ticket.assignedTo) === Number(state.intercomId));
                const unassignedOpenTickets = allOpenTickets.filter(ticket => ticket.assignedTo === null);
                commit('setAllOpenTickets', allOpenTickets);
                commit('setAssignedOpenTickets', assignedOpenTickets);
                commit('setUnassignedOpenTickets', unassignedOpenTickets);
            } catch (error) {
                console.error('Failed to fetch open tickets:', error);
            } finally {
                commit('setLoading', false);
            }
        },
        async fetchAgencyByEmail({ commit }, agencyEmail) {
            commit('setLoading', true);
            try {
                const response = await apiClient.get('/getters/getAgencyByEmail', {
                    headers: {
                        "Content-Type": "application/json",
                    },
                    params: {
                        agencyEmail, // Send email as query parameter
                    }
                });
                return response.data;
            } catch (error) {
                console.error('Failed to fetch agency by email:', error);
            } finally {
                commit('setLoading', false);
            }
        }
    },
};
